import React from "react";
import {withNamespaces} from "react-i18next";
import {Spinner} from "react-bootstrap";
import ContentPackageStatus from "../ContentPackageStatus";
import CheckboxColumn from "../CheckboxColumn";
import Moment from "react-moment";
import {formatterHelper} from "../../helpers/formatter-helper";

const DeviceContentInfo = ({t, contentModel, closeModal}) => {
    return (
        <div className="modal-content">
            { contentModel ? (
                <div>
                    <div className="modal-header">
                        <div className="modal-title">
                            <h5>{t('content-details')} / {contentModel.label} </h5>
                            <p>{contentModel.fileName}</p>
                        </div>
                        <button type="button" className="close" aria-label="Close" onClick={closeModal}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <table className="table table-sm table-borderless">
                            <tbody>
                            <tr>
                                <th scope="col">{t('label')}</th>
                                <td>{ contentModel.label } </td>
                            </tr>
                            <tr>
                                <th scope="col">{t('file-name')}</th>
                                <td>{ contentModel.fileName }</td>
                            </tr>
                            <tr>
                                <th scope="col">{t('file-path-server')} </th>
                                <td> { contentModel.filePath } </td>
                            </tr>
                            <tr>
                                <th scope="col">{t('executable')}</th>
                                <td>{ contentModel.exePath }</td>
                            </tr>
                            <tr>
                                <th scope="col">{t('arguments')}</th>
                                <td>{ contentModel.exeArgs || "-" }</td>
                            </tr>
                            <tr>
                                <th scope="col">{t('is-default')}</th>
                                <td><CheckboxColumn disabled={true} dataValue={contentModel.isDefault}/></td>
                            </tr>
                            <tr>
                                <th scope="col">{t('status')}</th>
                                <td><ContentPackageStatus packageStatus={contentModel.packageStatus} /></td>
                            </tr>

                            <tr>
                                <th scope="col">{t('content-override')}</th>
                                <td><CheckboxColumn disabled={true} dataValue={contentModel.override} /> </td>
                            </tr>
                            <tr>
                                <th scope="col">{t('use-resolution-check')}</th>
                                <td><CheckboxColumn disabled={true} dataValue={contentModel.useResolutionCheck}/></td>
                            </tr>
                            <tr hidden={!contentModel.useResolutionCheck} >
                                <th scope="col">{t('width')}</th>
                                <td>{ contentModel.width }</td>
                            </tr>
                            <tr hidden={!contentModel.useResolutionCheck}>
                                <th scope="col">{t('height')} </th>
                                <td> { contentModel.height } </td>
                            </tr>
                            <tr>
                                <th scope="col">{t('use-shell-execute')}</th>
                                <td><CheckboxColumn disabled={true} dataValue={contentModel.useShellExecute}/></td>
                            </tr>
                            <tr>
                                <th scope="col">{t('create-no-window')}</th>
                                <td><CheckboxColumn disabled={true} dataValue={contentModel.createNoWindow}/></td>
                            </tr>
                            <tr>
                                <th scope="col">{t('application-start-delay')}</th>
                                <td>{contentModel.applicationStartDelay}</td>
                            </tr>
                            <tr>
                                <th scope="col">{ t('upload-date') }</th>
                                <td><Moment format="YYYY-MM-DD HH:mm">{contentModel.uploadDate}</Moment></td>
                            </tr>
                            <tr>
                                <th scope="col">{ t('file-size') }</th>
                                <td>{ formatterHelper.byteToMegabyte(contentModel.fileSize) + " mb" }</td>
                            </tr>
                            <tr>
                                <th scope="col">{ t('user') }</th>
                                <td> { contentModel.userId } </td>
                            </tr>
                            <tr>
                                <th scope="col">{ t('version') }</th>
                                <td> { contentModel.version } </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            ) : (<Spinner animation={"grow"} />) }
        </div>
    )


};
export default withNamespaces()(DeviceContentInfo);
